<template>

    <v-autocomplete
      v-model="localSelectedItems"
      :items="items"
      :search-input.sync="search"
      hide-no-data
      hide-details
      :multiple="multiple"
      item-text="name"
      item-value="id"
      placeholder="Pricelist..."
      solo
      chips
    ></v-autocomplete>
</template>

<script>
  export default {
    props: {
      selected: null,
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      search: '',
      items: [],
      isLoading: false
    }),
    computed: {
      localSelectedItems: {
        get () {
          return this.selected
        },
        set (nv) {
          this.$emit('update:selected', nv)
          // this.$emit('change', this.items.filter(item => nv.includes(item.id)))
          // this.$emit('change', this.items.find(item => item.id === nv))
        }
      }
    },
    watch: {
      search (val) {
        this.fetchAPI()
      }
    },
    methods: {
      fetchAPI () {
        var filters = {
          search: this.search,
          selectedID: this.selectedID
        }
        const encodedFilters = btoa(JSON.stringify(filters))
        this.isLoading = true
        this.$axios.get('/price-lists/autocomplete?filters=' + encodedFilters)
          .then(response => {
            var rows = response.data.rows
            this.count = response.data.count
            console.log(response)
            this.items = rows //.filter(item => item.complete === 0)
          })
          .catch(error => console.log(error))
          .then(() => this.isLoading = false)
      }
    }
  }
</script>